<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Tidak Dapat Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan. Pastikan tidak ada nilai negatif pada embalase dan tuslah serta pastikan jumlah lebih dari 0',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div style="position: relative">
            <div class="d-flex flex-between my-3">
              <h5 class="mb-2">Resep Optik</h5>
            </div>
            <table class="responsive mb-3">
              <thead>
                <th>EYE</th>
                <th>SPH</th>
                <th>CYL</th>
                <th>AXIS</th>
                <th>ADD</th>
                <th>PD</th>
                <th>MPD</th>
                <th>PV</th>
                <th>PRISMA</th>
                <th>VISUS</th>
                <th>KET</th>
              </thead>
              <tbody>
                <tr>
                  <td>O.D.</td>
                  <td>
                    <input
                      type="number"
                      name="od_sph"
                      class="form-control"
                      v-model="formSet.od_sph"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_cyl"
                      class="form-control"
                      v-model="formSet.od_cyl"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_axis"
                      class="form-control"
                      v-model="formSet.od_axis"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_add"
                      class="form-control"
                      v-model="formSet.od_add"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_pd"
                      class="form-control"
                      v-model="formSet.od_pd"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_mpd"
                      class="form-control"
                      v-model="formSet.od_mpd"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_pv"
                      class="form-control"
                      v-model="formSet.od_pv"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_prsm"
                      class="form-control"
                      v-model="formSet.od_prsm"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="od_visus"
                      class="form-control"
                      v-model="formSet.od_visus"
                    />
                  </td>
                  <td>
                    <input
                      class="form-control desc"
                      name="od_ket"
                      v-model="formSet.od_ket"
                    />
                  </td>
                </tr>
                <tr>
                  <td>O.S.</td>
                  <td>
                    <input
                      type="number"
                      name="os_sph"
                      class="form-control"
                      v-model="formSet.os_sph"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_cyl"
                      class="form-control"
                      v-model="formSet.os_cyl"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_axis"
                      class="form-control"
                      v-model="formSet.os_axis"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_add"
                      class="form-control"
                      v-model="formSet.os_add"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_pd"
                      class="form-control"
                      v-model="formSet.os_pd"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_mpd"
                      class="form-control"
                      v-model="formSet.os_mpd"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_pv"
                      class="form-control"
                      v-model="formSet.os_pv"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_prsm"
                      class="form-control"
                      v-model="formSet.os_prsm"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="os_visus"
                      class="form-control"
                      v-model="formSet.os_visus"
                    />
                  </td>
                  <td>
                    <input
                      class="form-control desc"
                      v-model="formSet.os_ket"
                      name="os_ket"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="3">Visus Kacamata Lama</td>
                  <td>
                    <input
                      class="form-control desc"
                      v-model="formSet.visus_km_lama"
                      name="visus_km_lama"
                    />
                  </td>
                  <td colspan="3" class="text-right">Kategori Lensa</td>
                  <td colspan="4">
                    <select
                      class="form-control desc"
                      v-model="formSet.od_kategori_lensa"
                      name="od_kategori_lensa"
                    >
                      <option value="Kategori Lensa 1">Kategori Lensa 1</option>
                      <option value="Kategori Lensa 2">Kategori Lensa 2</option>
                      <option value="Kategori Lensa 3">Kategori Lensa 3</option>
                      <option value="Kategori Lensa 4">Kategori Lensa 4</option>
                      <option value="Kategori Lensa 5">Kategori Lensa 5</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="form-group">
              <div class="input-group">
                <input
                  type="text"
                  :class="
                    'form-control form-control-lg pl-5 with-icon-left without-label ' +
                      (isError ? 'error' : '')
                  "
                  placeholder="Cari kode atau nama optik di sini"
                  @input="
                    (e) => {
                      a_optik = false;
                      s_optik = e.target.value;
                      updateForm();
                    }
                  "
                  :value="s_optik"
                  v-on:keyup.enter="() => search('optik')"
                />
                <i
                  class="material-symbols-outlined"
                  style="margin-top: -0.25rem"
                  >search</i
                >
                <div class="input-group-append">
                  <button
                    class="btn btn-secondary btn-with-icon-left"
                    @click="() => search('optik')"
                  >
                    <i class="material-symbols-outlined">search</i>
                    CARI
                  </button>
                </div>
              </div>
            </div>
            <SearchResult
              type=""
              @addItem="(item) => addItem(item, 'optik')"
              v-if="s_optik && a_optik"
              :loading="l_optik"
              :data="r_optik"
            />
            <table v-if="optik.length" class="responsive">
              <thead>
                <th>KODE</th>
                <th>NAMA BARANG</th>
                <th>JENIS OPTIK</th>
                <th>LOKASI</th>
                <th>HARGA/PC</th>
                <th>JUMLAH</th>
                <th>EMBALASE</th>
                <th>TUSLAH</th>
                <th>SUB TOTAL</th>
                <th></th>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in optik"
                  v-bind:key="item.id + Math.random(1024)"
                  v-show="!item.deleted"
                >
                  <td>{{ item.kode }}</td>
                  <td>{{ item.nama }}</td>
                  <td>{{ item.jenis }}</td>
                  <td>{{ item.lokasi }}</td>
                  <td>{{ item.formatted_harga }}</td>
                  <td>
                    <InputNumber
                      @handleChange="(e) => handleChange(e)"
                      :value="item.jumlah"
                      :input="{ class: 'inline', name: 'jumlah-' + index }"
                    />
                  </td>
                  <td>
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.embalase"
                      :input="{
                        class: 'group-inline',
                        name: 'embalase-' + index,
                      }"
                    />
                  </td>
                  <td>
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.tuslah"
                      :input="{
                        class: 'group-inline',
                        name: 'tuslah-' + index,
                      }"
                    />
                  </td>
                  <td>{{ convertToRupiah(item.sub_total) }}</td>
                  <td>
                    <button
                      class="btn btn-icon btn-danger btn-sm"
                      @click="() => deleteItem('optik', item.id)"
                    >
                      <i class="material-symbols-outlined">delete</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Resep Optik
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  to="/ralan"
                  >Batalkan</router-link
                > -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/ralan')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResult from "@/components/SearchResult.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
// import FormRow from '@/components/FormRow.vue'
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import InputMoney from "@/components/InputMoney.vue";
import InputNumber from "@/components/InputNumber.vue";
import {
  setPatientIntro,
  setRawatIntro,
  convertToRupiah,
  discounted,
  formatDiscount,
} from "@/data/helper.js";
//console.log(discounted);
//console.log(formatDiscount);
// import { HTTP,HTTP_ENC } from "@/config.js";
import { data } from "@/data/RalanFormOptik.js";

export default {
  name: "RalanFormOptik",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    DetailLeft,
    DetailRight,
    InputMoney,
    InputNumber,
    Alert,
    SearchResult,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        no_rawat: "",
        id_resep: null,
        od_sph: 0,
        od_cyl: 0,
        od_axis: 0,
        od_add: 0,
        od_pd: 0,
        od_mpd: 0,
        od_pv: 0,
        od_prsm: 0,
        od_visus: 0,
        od_kategori_lensa: "",
        od_ket: "",
        os_sph: 0,
        os_cyl: 0,
        os_axis: 0,
        os_add: 0,
        os_pd: 0,
        os_mpd: 0,
        os_pv: 0,
        os_prsm: 0,
        os_visus: 0,
        os_ket: "",
        visus_km_lama: 0,
      },
      n: 0,
      s_optik: "",
      r_optik: [],
      optik: [],
      a_optik: false,
      l_optik: false,
      isError: false,
      jumlah: [],
      embalase: [],
      tuslah: [],
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    goBack(url) {
      //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      //console.log(backBtn);
      //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },

    handleForm: async function() {
      this.saveFailed = false;
      this.saveSuccess = false;
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.optik.filter(
          (item) => !(item.deleted && !item.id_ralan_optik)
        ).length;
        let optiks =
          this.optik && this.optik.length
            ? this.optik
                .filter((item) => !(item.deleted && !item.id_ralan_optik))
                .map((item) => {
                  return {
                    operation: item.deleted ? "delete" : null,
                    no_rawat: self.formSet["no_rawat"],
                    id_optik: item.id,
                    embalase: item.embalase,
                    tuslah: item.tuslah,
                    jumlah: item.jumlah,
                    sub_total: item.sub_total,
                  };
                })
            : [];
        if (optiks && optiks.length) {
          try {
            let result = await this.$store.state.HTTP_JSON.post(
              `/ralan/barang/optik-bulk`,
              { optiks }
            );
            //console.log(result);
            if (!result || result.status != 200) {
              this.saveFailed = true;
              this.saveSuccess = false;
              this.checkSuccess();
              return;
            }
          } catch (e) {
            //console.log(e);
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
        }
        try {
          let resep = `no_rawat=${self.formSet["no_rawat"]}&od_sph=${self.formSet.od_sph}&od_cyl=${self.formSet.od_cyl}&od_axis=${self.formSet.od_axis}&od_add=${self.formSet.od_add}&od_pd=${self.formSet.od_pd}&od_mpd=${self.formSet.od_mpd}&od_pv=${self.formSet.od_pv}&od_prsm=${self.formSet.od_prsm}&od_visus=${self.formSet.od_visus}&od_kategori_lensa=${self.formSet.od_kategori_lensa}&od_ket=${self.formSet.od_ket}&os_sph=${self.formSet.os_sph}&os_cyl=${self.formSet.os_cyl}&os_axis=${self.formSet.os_axis}&os_add=${self.formSet.os_add}&os_pd=${self.formSet.os_pd}&os_mpd=${self.formSet.os_mpd}&os_pv=${self.formSet.os_pv}&os_prsm=${self.formSet.os_prsm}&os_visus=${self.formSet.os_visus}&os_ket=${self.formSet.os_ket}&visus_km_lama=${self.formSet.visus_km_lama}`;
          //console.log(resep);
          let result;
          if (self.formSet.id_resep) {
            result = await this.$store.state.HTTP_ENC.put(
              `ralan/resep/optik/${self.formSet.id_resep}`,
              resep
            );
          } else {
            result = await this.$store.state.HTTP_ENC.post(
              `ralan/resep/optik`,
              resep
            );
          }
          if (!result || result.status != 200) {
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
          //console.log(result);
        } catch (e) {
          ////console.log(e);
          self.saveFailed = true;
          self.saveSuccess = false;
        }
        this.checkSuccess();
      } else {
        //console.log(valid);
        this.saveFailed = true;
        this.saveSuccess = false;
        this.checkSuccess();
      }
    },

    handleFormOld: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n =
          this.optik.filter((item) => !(item.deleted && !item.id_ralan_optik))
            .length + 1;

        this.optik.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `no_rawat=${self.formSet["no_rawat"]}&id_optik=${item.id}&harga=${item.harga}&jumlah=${item.jumlah}&embalase=${item.embalase}&tuslah=${item.tuslah}&sub_total=${item.sub_total}`;
            if (!item.id_ralan_optik) {
              await self.saveData(body);
            } else {
              await self.saveData(body, item.id_ralan_optik);
            }
          } else {
            if (item.id_ralan_optik) {
              await self.deleteData(item.id_ralan_optik);
            }
          }
        });

        try {
          let resep = `no_rawat=${self.formSet["no_rawat"]}&od_sph=${self.formSet.od_sph}&od_cyl=${self.formSet.od_cyl}&od_axis=${self.formSet.od_axis}&od_add=${self.formSet.od_add}&od_pd=${self.formSet.od_pd}&od_mpd=${self.formSet.od_mpd}&od_pv=${self.formSet.od_pv}&od_prsm=${self.formSet.od_prsm}&od_ket=${self.formSet.od_ket}&od_kategori_lensa=${self.formSet.od_kategori_lensa}&os_sph=${self.formSet.os_sph}&os_cyl=${self.formSet.os_cyl}&os_axis=${self.formSet.os_axis}&os_add=${self.formSet.os_add}&os_pd=${self.formSet.os_pd}&os_mpd=${self.formSet.os_mpd}&os_pv=${self.formSet.os_pv}&os_prsm=${self.formSet.os_prsm}&os_ket=${self.formSet.os_ket}`;
          //console.log(resep);
          let result;
          if (self.formSet.id_resep) {
            result = await this.$store.state.HTTP_ENC.put(
              `ralan/resep/optik/${self.formSet.id_resep}`,
              resep
            );
          } else {
            result = await this.$store.state.HTTP_ENC.post(
              `ralan/resep/optik`,
              resep
            );
          }
          if (result.status == "200") {
            self.n = self.n - 1;
            if (self.n == 0) {
              self.checkSuccess();
            }
          }
          //console.log(result);
        } catch (e) {
          //console.log(e);
          self.saveFailed = true;
          self.saveSuccess = false;
        }
      } else {
        //console.log(valid);
      }
    },
    async saveData(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `ralan/barang/optik/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `ralan/barang/optik`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteData(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `ralan/barang/optik/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          let queryString = "";
          if (that.$route.query.fromTab) {
            queryString = `?tab=${that.$route.query.fromTab}`;
          }
          that.$router.push(
            `/ralan/detail/${that.$route.params.id}${queryString}`
          );
        }, 1000);
      }
    },
    handleChange(e) {
      // if (e.target.type == "file") {
      //   if(e.target.files && e.target.files.length) { this.formSet[e.target.name] = e.target.files[0]; }
      // } else {
      //   this.formSet[e.target.name] = e.target.value;
      // }
      let name = e.target.name.split("-")[0];
      let index = e.target.name.split("-")[1];
      this.optik[index][name] = parseInt(e.target.value || 0);
      //console.log(this.optik[index][name]);
      this.optik[index]["sub_total"] =
        this.optik[index].jumlah * this.optik[index].harga +
        this.optik[index].embalase +
        this.optik[index].tuslah;
      this.optik.splice(index, 1, this.optik[index]);
      //console.log(this.optik[index]);
      // this.updateForm();
    },

    updateForm() {
      // this.optikForm[0].columns[0].value=String(this.formSet['id_petugas']);
      // this.optikForm[0].columns[1].value=String(this.formSet['id_dokter']);
      // this.labForm[0].columns[0].value=String(this.formSet['id_petugas_lab']);
      // this.labForm[0].columns[1].value=this.formSet['lab_type'];
    },
    validateForm: function() {
      let valid = true;
      // let self = this;
      // let self=this.formSet;
      this.optik.forEach((item) => {
        if (
          parseInt(item.jumlah) < 1 ||
          parseInt(item.embalase) < 0 ||
          parseInt(item.tuslah) < 0
        ) {
          valid = false;
          return;
        }
      });
      return valid;
    },
    fetchData: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/barang/optik?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_optik = item.id;
            item.id = item.optik.id;
            item.kode = item.optik.kode;
            item.nama = item.optik.nama;
            item.jenis = item.optik.jenis;
            item.lokasi = item.optik.lokasi;
            self.optik.push(item);
          });
          self.optik = self.optik.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchResep: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/optik?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        // let self=this;
        if (result.status == "200") {
          //console.log(result);
          if (result.data) {
            this.formSet = result.data;
            this.formSet.id_resep = this.formSet.id;
            //console.log(this.formSet);
          }
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "lab") {
        url = "periksalab";
      } else {
        url = "optik";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            // item.formatted_harga=self.convertToRupiah(item.harga);
            //console.log(item.harga);
            //console.log(item.formatted_harga);
            item.formatted_diskon = formatDiscount(
              item.tipe_diskon,
              item.diskon
            );
            item.harga_awal = item.harga;
            item.harga = discounted(
              parseInt(item.harga),
              item.tipe_diskon,
              parseFloat(item.diskon)
            );
            item.formatted_harga = convertToRupiah(item.harga);
            //console.log(item);
            return item;
          });
          //console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        item.jumlah = 1;
        item.embalase = 0;
        item.tuslah = 0;
        item.sub_total = item.harga;
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=0`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        //console.log(this.formSet['no_rawat']);
      } else {
        //   this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchResep();
    this.fetchData();
  },
};
</script>
